import classNames from 'classnames';
import { CASUALITY_GENERAL } from 'containers/Casuality-General/constantes';
import { CASUALITY } from 'containers/Casuality/constantes';
import { LF } from 'containers/LineasFinancieras/Constantes/general';
import { SEGUKIDS } from 'containers/Segurykids/constants';
import useCustomRouter from 'hooks/useCustomRouter';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import PRODUCTOS from 'utils/constants/PRODUCTOS';

const AtrasButton = ({ codProducto, newRoutes, isPagoRealizado, idPoliza }) => {
  const methods = useFormContext();
  const history = useCustomRouter();

  return (
    <React.Fragment>
      {!['tradicional', 'online'].includes(methods.watch('tipoPago')) &&
        [
          PRODUCTOS.HOGAR,
          PRODUCTOS.HOGAR_DTC,
          PRODUCTOS.HOGAR_FLEX,
          PRODUCTOS.LINEAS_FINANCIERAS,
          PRODUCTOS.RCP,
          PRODUCTOS.CYBER,
          PRODUCTOS.MARINE_INLAND,
          PRODUCTOS.DO,
          PRODUCTOS.CASUALITY,
          PRODUCTOS.CASUALITY_GENERAL,
          PRODUCTOS.AUTO,
          PRODUCTOS.SEGUKIDS,
        ].includes(codProducto) &&
        !isPagoRealizado && (
          <div className="row justify-content-around">
            <div
              className={classNames({
                'col-sm-11 col-lg-10': PRODUCTOS.SEGUKIDS === codProducto,
                'col-11 col-xl-8': PRODUCTOS.SEGUKIDS !== codProducto,
              })}
            >
              <div className="row justify-content-center">
                <div
                  className={classNames({
                    'col-11 col-md-6 col-lg-4': PRODUCTOS.SEGUKIDS === codProducto,
                    'col-11 col-md-6': PRODUCTOS.SEGUKIDS !== codProducto,
                  })}
                >
                  <button
                    className={classNames('btn btn-primary btn-block', {
                      'btn-segukids px-3': PRODUCTOS.SEGUKIDS === codProducto,
                    })}
                    type="button"
                    onClick={() => {
                      if (codProducto === PRODUCTOS.LINEAS_FINANCIERAS) {
                        return history.push(`${LF.urls.vigencia}?idPoliza=${idPoliza}`);
                      }

                      if (codProducto === PRODUCTOS.CASUALITY) {
                        return history.push(`${CASUALITY.urls.contratante}?id=${idPoliza}`);
                      }
                      if (codProducto === PRODUCTOS.CASUALITY_GENERAL) {
                        return history.push(`${CASUALITY_GENERAL.urls.vigencia}?id=${idPoliza}`);
                      }
                      if (codProducto === PRODUCTOS.SEGUKIDS) {
                        return history.push(`${SEGUKIDS.urls.asegurado}?idPoliza=${idPoliza}`);
                      }
                      return history.push(newRoutes.suscripcion.goBack);
                    }}
                  >
                    {PRODUCTOS.SEGUKIDS === codProducto && (
                      <i
                        className="pi pi-arrow-left"
                        style={{
                          position: 'relative',
                          top: '1px',
                          fontSize: '1.4rem',
                          paddingRight: '5px',
                        }}
                      />
                    )}
                    ATRÁS
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
    </React.Fragment>
  );
};

export default AtrasButton;
